module.exports = "/_next/static/images/fulfillment-5c8403a131b89d9aa66fda18efa2813a.png.webp";